import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';

import { DashboardChart, CasesNumberBlock, DashboardCasesTable, NotificationsBlock } from '../../../components/home';
import LoadScreen from '../../../components/load-screen';

import { getSurgeons } from '../../../actions/surgeonsActions';
import { getProcedures } from '../../../actions/proceduresActions';
import { getCases } from '../../../actions/casesActions';

import { useLoading } from '../../../hooks';

import { prepareCasesDataWeekly, getTenantColors } from '../../../utils/analytics';

import { caseStatusOptions } from '../../../constants/enums';

import './home-page.scss';

const today = moment().local().format('MMM Do YYYY');

const HomePage = () => {
  const dispatch = useDispatch();
  const tenantColor = useSelector((state) => state.tenant.currentTenant.colorPrimary);
  // const connectedCases = useSelector((state) => state.cases.connectedCases?.filter((item) => !!item.active)) || [];
  // const completedCases = useSelector((state) => state.cases.completedCases);
  // const completedLoaded = useSelector((state) => state.cases.completedLoaded);
  const surgeons = useSelector((state) => state.surgeons.list);
  const hospitals = useSelector((state) => state.hospitals.list);
  const procedures = useSelector((state) => state.procedures.list);
  const notifications = useSelector((state) => state.notifications.list);

  const { loading } = useLoading();

  const [cases, setCases] = useState([]);
  const [casesThisWeek, setCasesThisWeek] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isWeekLoaded, setIsWeekLoaded] = useState(false);

  useEffect(() => {
    onLoad().catch((err) => console.error(err));
  }, []);

  const onLoad = async () => {
    fetchCases().catch();
    fetchCasesThisWeek().catch();
    if (!surgeons.length || !procedures.length) {
      try {
        await Promise.all([
          dispatch(getSurgeons()),
          dispatch(getProcedures()),
        ]);
      } catch (err) {
        console.error(err);
      }
    }
  };

  const fetchCases = async () => {
    try {
      const params = {
        search: '*',
        page: 1,
        perPage: 5,
        sortBy: 'date',
        sortOrder: 'asc',
        active: true,
        statuses: [caseStatusOptions.request, caseStatusOptions.booked],
        dateFrom: moment().startOf('day').valueOf(),
      };

      const res = await dispatch(getCases(params));
      if (res && res.cases) {
        setCases(res.cases);
        setIsLoaded(true);
      }
    } catch (err) {
      console.log(err);
    }
  };
  
  const fetchCasesThisWeek = async () => {
    try {
      const params = {
        search: '*',
        page: 1,
        perPage: 100,
        sortBy: 'date',
        sortOrder: 'asc',
        active: true,
        dateFrom: moment().startOf('week').valueOf(),
        dateTo: moment().endOf('week').valueOf(),
      };

      const res = await dispatch(getCases(params));
      if (res && res.cases) {
        setCasesThisWeek(res.cases);
        setIsWeekLoaded(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const chartData = useMemo(() => prepareCasesDataWeekly(casesThisWeek), [casesThisWeek]);
  
  return (
    <div className="page-container home-page__container">
      {loading && <LoadScreen />}
      <div className="page-title">
        Dashboard
        <span className="page-subtitle">{today}</span>
      </div>
      <div className="home-page__body">
        <div>
          <div className="home-page__row-container">
            <DashboardChart
              data={chartData}
              tenantColor={getTenantColors(chartData, tenantColor)}
              loading={!isWeekLoaded}
            />

            <CasesNumberBlock
              cases={casesThisWeek}
              completedCases={casesThisWeek.filter((caseItem) => caseItem.status === caseStatusOptions.completed)}
              completedLoaded
            />

            {/*<CasesNumberBlock*/}
            {/*  cases={[...cases, ...connectedCases]}*/}
            {/*  completedCases={[...completedCases, ...connectedCases?.filter((caseItem) => caseItem.status === caseStatusOptions.completed)]}*/}
            {/*  completedLoaded={completedLoaded}*/}
            {/*/>*/}
          </div>

          <DashboardCasesTable
            cases={cases}
            surgeons={surgeons}
            hospitals={hospitals}
            procedures={procedures}
            isLoaded={isLoaded}
          />
        </div>

        <NotificationsBlock
          notifications={notifications}
          tenantColor={tenantColor}
        />
      </div>
    </div>
  );
};

export default HomePage;
